export default __webpack_public_path__ + "static/media/icon-sightx-featured.28811cde.svg";